/**
 * TGFM Auto Tabs - Trasforma automaticamente la descrizione prodotto in tabs
 * Rileva gli heading (h2, h3) e crea tabs navigabili.
 *
 * Comportamento difensivo:
 * - costruisce le sezioni candidate in memoria prima di toccare il DOM;
 * - scarta sezioni con titolo vuoto o senza contenuto reale;
 * - se restano meno di 2 sezioni valide, lascia la descrizione originale intatta;
 * - "Panoramica" viene creato solo se il contenuto introduttivo ha testo o media reali.
 */

(function() {
  'use strict';

  var MEDIA_TAGS = ['IMG', 'VIDEO', 'IFRAME', 'PICTURE', 'SVG', 'SOURCE', 'EMBED'];

  document.addEventListener('DOMContentLoaded', function() {
    initAutoTabs();
  });

  function initAutoTabs() {
    var description = document.querySelector('.product-description, .product-description.rte, .product-block--description .rte');
    if (!description) return;

    var headings = description.querySelectorAll('h2, h3');
    if (headings.length < 2) return;

    var candidates = collectCandidateSections(description, headings);
    var valid = candidates.filter(isValidSection);

    if (valid.length < 2) return;

    var tabsContainer = document.createElement('div');
    tabsContainer.className = 'tgfm-auto-tabs';

    var tabsNav = document.createElement('div');
    tabsNav.className = 'tgfm-tabs-nav';

    var tabsContent = document.createElement('div');
    tabsContent.className = 'tgfm-tabs-content';

    valid.forEach(function(section, index) {
      var isActive = index === 0;
      var tab = createTab(section.title, section.contentNodes, index, isActive);
      tabsNav.appendChild(tab.button);
      tabsContent.appendChild(tab.panel);
    });

    tabsContainer.appendChild(tabsNav);
    tabsContainer.appendChild(tabsContent);

    description.innerHTML = '';
    description.appendChild(tabsContainer);

    description.style.background = 'transparent';
    description.style.padding = '0';
    description.style.border = 'none';

    setupTabListeners(tabsContainer);
  }

  function collectCandidateSections(description, headings) {
    var sections = [];

    var introNodes = [];
    var cursor = description.firstChild;
    while (cursor && !isHeading(cursor)) {
      if (shouldCloneNode(cursor)) {
        introNodes.push(cursor.cloneNode(true));
      }
      cursor = cursor.nextSibling;
    }
    if (introNodes.length > 0) {
      sections.push({
        title: 'Panoramica',
        contentNodes: introNodes,
        isIntro: true
      });
    }

    for (var i = 0; i < headings.length; i++) {
      var heading = headings[i];
      var title = (heading.textContent || '').trim();
      var contentNodes = getContentUntilNextHeading(heading);
      sections.push({
        title: title,
        contentNodes: contentNodes,
        isIntro: false
      });
    }

    return sections;
  }

  function isValidSection(section) {
    if (!section.isIntro) {
      if (!section.title || section.title.length === 0) return false;
    }
    return hasRealContent(section.contentNodes);
  }

  function shouldCloneNode(node) {
    if (!node) return false;
    if (node.nodeType === 1) return true;
    if (node.nodeType === 3) return !!(node.textContent && node.textContent.trim().length > 0);
    return false;
  }

  function isHeading(node) {
    return !!(node && node.nodeType === 1 && (node.tagName === 'H2' || node.tagName === 'H3'));
  }

  function hasRealContent(nodes) {
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (!node) continue;
      if (node.nodeType === 3) {
        if (node.textContent && node.textContent.trim().length > 0) return true;
        continue;
      }
      if (node.nodeType === 1) {
        var text = (node.textContent || '').trim();
        if (text.length > 0) return true;
        if (containsMedia(node)) return true;
      }
    }
    return false;
  }

  function containsMedia(element) {
    if (!element) return false;
    if (element.tagName && MEDIA_TAGS.indexOf(element.tagName) !== -1) return true;
    if (!element.querySelector) return false;
    for (var i = 0; i < MEDIA_TAGS.length; i++) {
      if (element.querySelector(MEDIA_TAGS[i].toLowerCase())) return true;
    }
    return false;
  }

  function getContentUntilNextHeading(heading) {
    var content = [];
    var sibling = heading.nextSibling;
    while (sibling && !isHeading(sibling)) {
      if (shouldCloneNode(sibling)) {
        content.push(sibling.cloneNode(true));
      }
      sibling = sibling.nextSibling;
    }
    return content;
  }

  function createTab(title, contentNodes, index, isActive) {
    var button = document.createElement('button');
    button.className = 'tgfm-tab-btn' + (isActive ? ' active' : '');
    button.setAttribute('data-tab-index', index);
    button.setAttribute('role', 'tab');
    button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    button.innerHTML = '<span class="tgfm-tab-icon"></span><span class="tgfm-tab-text">' + escapeHtml(title) + '</span>';

    var panel = document.createElement('div');
    panel.className = 'tgfm-tab-panel' + (isActive ? ' active' : '');
    panel.setAttribute('data-tab-index', index);
    panel.setAttribute('role', 'tabpanel');

    contentNodes.forEach(function(node) {
      panel.appendChild(node);
    });

    return { button: button, panel: panel };
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function setupTabListeners(container) {
    var buttons = container.querySelectorAll('.tgfm-tab-btn');
    var panels = container.querySelectorAll('.tgfm-tab-panel');

    buttons.forEach(function(button) {
      button.addEventListener('click', function() {
        var targetIndex = this.getAttribute('data-tab-index');

        buttons.forEach(function(btn) {
          btn.classList.remove('active');
          btn.setAttribute('aria-selected', 'false');
        });
        panels.forEach(function(panel) {
          panel.classList.remove('active');
        });

        this.classList.add('active');
        this.setAttribute('aria-selected', 'true');
        var targetPanel = container.querySelector('.tgfm-tab-panel[data-tab-index="' + targetIndex + '"]');
        if (targetPanel) targetPanel.classList.add('active');
      });
    });
  }

})();
